import React, { useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronLeftIcon, ChevronRightIcon, XIcon } from "lucide-react";
import { LIGHTBOX_EVENT } from "./StickyOfferBar";
type Page = {
  label: string;
  src: string;
};
type Props = {
  pages: Page[];
  index: number | null;
  onClose: () => void;
  onChange: (index: number) => void;
};
export function PageLightbox({
  pages,
  index,
  onClose,
  onChange
}: Props) {
  const open = index !== null;
  useEffect(() => {
    window.dispatchEvent(new CustomEvent(LIGHTBOX_EVENT, {
      detail: open
    }));
  }, [open]);
  useEffect(() => {
    if (!open) return;
    function onKey(e: KeyboardEvent) {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight" && index !== null && index < pages.length - 1) onChange(index + 1);
      if (e.key === "ArrowLeft" && index !== null && index > 0) onChange(index - 1);
    }
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [open, index, pages.length, onClose, onChange]);
  const btn = "inline-flex h-11 w-11 items-center justify-center rounded-full bg-white text-petrol shadow transition-colors duration-150 ease-out hover:bg-sage disabled:opacity-30";
  return <AnimatePresence data-id="element-126" data-mp="1e60nl0bvhau3">
      {open && index !== null && <motion.div role="dialog" aria-modal="true" aria-label={pages[index].label} className="fixed inset-0 z-50 flex flex-col items-center justify-center gap-4 bg-ink/85 p-4" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2,
      ease: [0.23, 1, 0.32, 1]
    }} onClick={onClose} data-id="element-127" data-mp="hjds7k26vt83">
          <button type="button" onClick={onClose} aria-label="Close" className={`${btn} absolute right-4 top-4`} autoFocus data-id="element-128" data-mp="3uuwfam6yjluy">
            <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-129" data-mp="1643v5wbplsgv" />
          </button>
          <motion.img key={pages[index].src} src={pages[index].src} alt={pages[index].label} onClick={e => e.stopPropagation()} className="max-h-[78vh] w-auto max-w-full rounded-lg bg-white object-contain shadow-2xl" initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-130" data-mp="1620wyp0ekt12" />
          <div className="flex items-center gap-4" onClick={e => e.stopPropagation()} data-id="element-131" data-mp="i76lea1mvwwb">
            <button type="button" className={btn} disabled={index === 0} onClick={() => onChange(index - 1)} aria-label="Previous page" data-id="element-132" data-mp="w668vedeu5qw">
              <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-133" data-mp="s31ano0d4q82" />
            </button>
            <p className="min-w-[180px] text-center text-sm font-semibold text-white" data-id="element-134" data-mp="27ji9zhhsca9d">{pages[index].label}</p>
            <button type="button" className={btn} disabled={index === pages.length - 1} onClick={() => onChange(index + 1)} aria-label="Next page" data-id="element-135" data-mp="23j7yjpb84rn4">
              <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-136" data-mp="2152ulrt3sho3" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}